import React from 'react';
import _ from 'lodash';
import { useReactiveVar } from '@apollo/client';
import { useTheme } from '@mui/material';
import { filterPlansVar } from 'modules/common/layer00/reactiveVariables';
import { CustomIcon } from 'modules/components/layer00';
import { StyledTextField } from 'modules/components/layer01';



export type PlanSearchBarProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanSearchBarProps) => {
  const theme = useTheme();
  const plansFilter = useReactiveVar(filterPlansVar);
  return (
    <StyledTextField.FC
      placeholder='Search'
      value={_.isNull(plansFilter.freeTextSearch) ? '' : plansFilter.freeTextSearch}
      startAdornment={(
        <CustomIcon.large.FC
          icon='SEARCH'
          stroke={theme.palette.primary.main}
        />
      )}
      onChange={(e) => {
        filterPlansVar({
          ...plansFilter,
          freeTextSearch: e.target.value === '' ? null : e.target.value
        });
      }}
    />

  );
};
